import GlobalApi from '../api/global'
import {
mapGetters
} from 'vuex';
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


const mixin = {
directives: {
TransferDom
},
computed: {



},
data() {
return {}
},
created: function () {
this.setDocumentTitleFn()

},
activated() {

},
beforeDestroy() {

},
methods: {
setDocumentTitleFn() {
document.title = this.$route.meta.title || '' 

}










}
}

export default mixin



// WEBPACK FOOTER //
// ./src/mixins/index.js